export function parse(message: string, ...params: (string | number)[]): string {
	return message.replace(/\$(\d+)/g, (_, index) => String(params[parseInt(index, 10)]));
}
